import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ReportCustomField } from './useReportCustomFields';

export const THEME_VISIBILITY_ID = -1;
export const SPECIFICATION_VISIBILITY_ID = -2;
export const ACTIVITY_TYPE_VISIBILITY_ID = -3;
export const DISTRIBUTION_VISIBILITY_ID = -4;

export const useReportSystemFields = () => {
  const { formatMessage } = useIntl();

  const activityTypeField = useMemo<ReportCustomField>(() => ({
    id: ACTIVITY_TYPE_VISIBILITY_ID,
    name: formatMessage({ id: 'Activity type' }),
    customFieldType: 'Selection' as ReportCustomField['customFieldType'],
    systemFieldId: null as unknown as ReportCustomField['systemFieldId'],
    options: []
  }), [formatMessage]);

  const themeField = useMemo<ReportCustomField>(() => ({
    id: THEME_VISIBILITY_ID,
    name: formatMessage({ id: 'Themes' }),
    customFieldType: 'Selection' as ReportCustomField['customFieldType'],
    systemFieldId: null as unknown as ReportCustomField['systemFieldId'],
    options: []
  }), [formatMessage]);

  const specificationField = useMemo<ReportCustomField>(() => ({
    id: SPECIFICATION_VISIBILITY_ID,
    name: formatMessage({ id: 'Specifications' }),
    customFieldType: 'Selection' as ReportCustomField['customFieldType'],
    systemFieldId: null as unknown as ReportCustomField['systemFieldId'],
    options: []
  }), [formatMessage]);

  const distributionField = useMemo<ReportCustomField>(() => ({
    id: DISTRIBUTION_VISIBILITY_ID,
    name: formatMessage({ id: 'Distributed items' }),
    customFieldType: 'Selection' as ReportCustomField['customFieldType'],
    systemFieldId: null as unknown as ReportCustomField['systemFieldId'],
    options: []
  }), [formatMessage]);

  const systemFields = useMemo(
    () => [activityTypeField, themeField, specificationField, distributionField],
    [activityTypeField, themeField, specificationField, distributionField]
  );

  return {
    systemFields,
    activityTypeField,
    themeField,
    specificationField,
    distributionField,
  };
};
